<template>
    <div>
        <form method="POST" @submit.prevent="saveContact">
            <div class="flex py-2">
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-6/12 md:pr-2">
                    <label>
                        <span class="text-gray-700">Nome<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="text"
                            placeholder="Il tuo nome" v-model="form.name" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-6/12 md:pl-2">
                    <label>
                        <span class="text-gray-700">Cognome<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="text"
                            placeholder="Il tuo cognome" v-model="form.last_name" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <ValidationProvider name="email" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full">
                    <label>
                        <span class="text-gray-700">Email<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="email"
                            placeholder="Email" v-model="form.email" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="w-full mt-4">
                <ValidationProvider name="phone" rules="required" :bails="false" v-slot="{ errors }">
                    <span class="text-gray-700">Cellulare<span class="text-red-600">*</span></span>
                    <div class="flex">
                        <div>
                            <vue-country-code @onSelect="onSelect"
                                :onlyCountries="['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'MD', 'NL', 'PL', 'PT', 'RO', 'RS', 'SK', 'SI', 'ES', 'SE', 'UA', 'CH']"
                                :defaultCountry="'IT'">
                            </vue-country-code>
                        </div>
                        <div>
                            <input
                                class="block w-full p-3 border border-gray-300 border-solid rounded-r focus:outline-none"
                                minlength="9" maxlength="10" type="text" v-on:keypress="NumbersOnly"
                                placeholder="1234567891" v-model="form.phone" required>
                        </div>
                    </div>
                    <span class="text-xs font-bold error-notice">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Città<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="text"
                            placeholder="Città" v-model="form.city" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>

            <div class="flex py-2">
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Paese<span class="text-red-600">*</span></span>
                        <select class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded"
                            v-model="form.selectedCountry">
                            <option value="" disabled>Select a country</option>
                            <option v-for="(country, code) in countries" :key="code" :value="`${country.name} (${code})`">
                                {{ country.name }} ({{ code }})
                            </option>
                        </select> </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            

            <div class="flex py-2" v-if="form.selectedCountry == 'Italy (IT)'">
                <ValidationProvider name="province" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Regione<span class="text-red-600">*</span></span>
                        <select v-model="form.region"
                            class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:outline-none focus:shadow-outline">
                            <option value="" selected hidden disabled>Seleziona Regione</option>
                            <option v-for="region in allregions" :key="region.id" :value="region.id">{{ region.name }}
                            </option>
                        </select>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            
            
            <div class="flex py-2"  v-if="form.selectedCountry == 'Italy (IT)'">
                <ValidationProvider name="province" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Provincia<span class="text-red-600">*</span></span>
                        <select v-model="form.province"
                            class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:outline-none focus:shadow-outline">
                            <option value="" selected hidden disabled>Seleziona Provincia</option>
                            <option v-for="province in provinces2" :key="province.id" :value="province.id" v-if="province.region_id == form.region">{{
                                province.name }}</option>
                        </select>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex py-2">
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Azienda<span class="text-red-600">*</span></span>
                        <input class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded" type="text"
                            placeholder="Azienda" v-model="form.company" required>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
                </div>
                <div class="flex py-2">

                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors }"
                    class="block w-full md:w-12/12">
                    <label>
                        <span class="text-gray-700">Ruolo<span class="text-red-600">*</span></span>
                        <select v-model="form.company_role"
                            class="block w-full px-2 py-3 pr-8 bg-white border border-gray-300 rounded shadow appearance-none hover:border-gray-400 focus:outline-none focus:shadow-outline">
                            <option value="" selected hidden disabled>Seleziona Ruolo</option>
                            <option v-for="role in jobroles" :key="role.id" :value="role.id">{{ role.name }}</option>
                        </select>
                    </label>
                    <span class="text-xs text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="flex justify-start w-full pt-4">
                <ValidationProvider name="privacy" rules="required|exact_length:1" :bails="false" v-slot="{ errors }"
                    class="items-center">
                    <label>
                        <input type="checkbox" value="1" v-model="form.privacy" required>
                        <span class="ml-2 text-xs">Dichiaro di aver ricevuto, letto e compreso l'<a
                                href="https://eventiosm.it/privacy-policy" target="blank"
                                class="font-semibold text-pink-600 hover:underline">informativa</a> ai sensi del Reg. UE
                            2016/679 (Art. 13) e presto il consenso al trattamento dei miei dati personali.</span>
                    </label><br>
                    <span class="text-xs text-red-600 help-block" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <button :disabled="!isComplete" type="submit" @click="showSuccess = true" v-show="!showSuccess"
                class="px-4 py-1 my-3 text-center text-white bg-blue-500 shadow-xl rounded-xl">sì, desidero ricevere
                maggiori informazioni</button>
        </form>

        <div v-show="showSuccess == true">
            <p class="px-2 py-3 text-lg font-semibold text-green-500 bre">Il tuo messaggio è stato inviato
                correttamente.<br>Riceverai maggiori informazioni a breve.</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { ValidationProvider } from 'vee-validate';
import "../vee-validate.js";
import VueCountryCode from "vue-country-code";
import { countries } from "countries-list";


export default {
    components: {
        ValidationProvider,
        VueCountryCode,
    },
    props: ['event', 'provinces2','allregions','jobroles'],
    data() {
        return {
            showSuccess: false,
            code: '',
            countries: countries, // Get the list of countries from the package
            form: {
                email: '',
                name: '',
                last_name: '',
                phone: '',
                company: '',
                company_role: '',
                city: this.city,
                privacy: '',
                province: '',
                selectedCountry: "Italy (IT)",
                region:'',
            },
        };
    },
    computed: {
        isComplete() {
            const isItaly = this.form.selectedCountry === "Italy (IT)";       

            return this.form.email && this.form.name && this.form.last_name && this.form.phone && this.form.city && 
            this.form.company_role && this.form.privacy &&this.form.selectedCountry &&
               (!isItaly || (this.form.region && this.form.province)); // Require `region` & `province` only for Italy
;
        }
    },
    methods: {
        onSelect({ iso2 }) {
            this.code = iso2;
        },
        saveContact(e) {
            e.preventDefault();
            let currentObj = this;
            axios.post('/api/store/contact', {
                type: 2,
                email: this.form.email,
                name: this.form.name,
                last_name: this.form.last_name,
                phone: this.form.phone,
                company: this.form.company,
                role: this.form.company_role,
                city: this.form.city,
                province: this.form.province,
                event: this.event,
                region: this.form.region,
                nation: this.form.selectedCountry,
            })
        },
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return false;
            }
        }

    }
}
</script>

<style lang="scss" scoped>
input:valid {
    border-color: #10b981;
    background-color: #deeee9;
}

button[disabled] {
    opacity: 0.35;
}

input[type=radio] {
    margin-right: 8px;
}

.select select.changed,
.input.changed {
    border: 2px solid #7ED321;
}

.select select.passed,
.input.passed {
    border: 2px solid #7ED321;
    background: rgb(214, 238, 188);
}

.vue-country-select {
    border-right: 0px;
    border-top: 1px solid #d1d5db;
    border-bottom: 1px solid #d1d5db;
    border-left: 1px solid #d1d5db;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background: white;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    height: 3.1rem;
}
</style>